<template>
    <div class="main admin-tests-edit">
        <div class="title-bar">
            <h1 class="mb-0">Form Results</h1>
            <a class="btn-back" :href="route('admin.forms.submissions.index', { form: submission.form_id })">
                <span class="icon icon-arrow-left"></span>
                <span class="text">Back to List</span>
            </a>
        </div>

        <div class="row py-4 px-4 align-items-start flex-row-reverse">
            <div class="col-md-4 details-pane p-3 m-md-0 m-5">
                <h3>{{submission.form.name}}</h3>
                <p></p>
                <p class="user">
                    <b>User:</b>
                    {{ submission.created_by.first_name }} {{ submission.created_by.last_name }}
                </p>
                <p class="email"><b>Email:</b> {{ submission.created_by.email }}</p>
                <p class="time"><b>Submitted On:</b> {{submission.created_at | moment("MM/DD/YYYY")}}</p>
            </div>
            <div class="col-md-8 pr-md-5">
                <div v-for="(response, count) in submission.responses" :key="count" class="mb-4 p-3">
                    <div v-if="response">
                        <label :for="'response-' + count">{{response.label}}</label>
                        <div class="mt-2">
                            <template v-if="response.type === fieldTypeMap.TEXTAREA_FIELD">
                                <textarea class="form-control" rows="5" disabled>{{response.value}}</textarea>
                            </template>
                            <template v-else>
                                <input type="text" class="form-control" disabled :value="response.value" />
                            </template>
                        </div>
                    </div>
                    <div v-else class="alert alert-danger">
                        It looks like this question was deleted or changed.
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import FieldEditor from "mixins/Forms/FieldEditor";

export default {
    mixins: [DisplaysAlerts], 
    components: { FieldEditor }, 
    props: {
        submission: { type: Object, required: true }
    },
    data() {
        return {
            fieldTypeMap: {}
        };
    },
    computed: {},
    watch: {
        //
    },
    mounted() {
        //
    },
    created() {
        this.fieldTypeMap = {
            TEXT_FIELD: "text",
            TEXTAREA_FIELD: "textarea",
            SELECT_FIELD: "select",
            CHECKBOX_FIELD: "checkbox",
            RADIO_FIELD: "radio",
            HTML_FIELD: "html",
            RATING_FIELD: "rating",
            DATE_FIELD: "date"
        };
    }
};
</script>